(function () {
    'use strict';
    var PINCODE_API_URL = 'https://amal-pincode-checker.vercel.app/api/check-pincode';
    function initPincodeChecker(root) {
    var input = root.querySelector('[data-pincode-input]');
    var button = root.querySelector('[data-pincode-check-btn]');
    var message = root.querySelector('[data-pincode-message]');
    if (!input || !button || !message) return;
    var form = root.closest('form');
    var targets = [];
    if (form) {
    var atcBtn = form.querySelector('[ref="addToCartButton"]');
    if (atcBtn) targets.push(atcBtn);
    var coBtn = form.querySelector('button[name="checkout"]');
    if (coBtn) targets.push(coBtn);
    }
    if (!targets.length) {
    var all = document.querySelectorAll('button[name="checkout"]');
    for (var i = 0; i < all.length; i++) targets.push(all[i]);
    }
    if (!targets.length) return;
    var isServiceable = false;
    function setMessage(text, type) {
    message.textContent = text;
    message.classList.remove('is-success', 'is-error');
    if (type) message.classList.add(type);
    }
    function lockButtons() {
    isServiceable = false;
    for (var i = 0; i < targets.length; i++) targets[i].setAttribute('disabled', 'disabled');
    }
    function unlockButtons() {
    isServiceable = true;
    for (var i = 0; i < targets.length; i++) targets[i].removeAttribute('disabled');
    }
    lockButtons();
    input.addEventListener('input', function () {
    if (isServiceable) {
    lockButtons();
    setMessage('', null);
    }
    });
    button.addEventListener('click', function () {
    var pincode = (input.value || '').trim();
    if (!/^[0-9]{6}$/.test(pincode)) {
    lockButtons();
    setMessage('Please enter a valid 6-digit pincode.', 'is-error');
    return;
    }
    button.disabled = true;
    setMessage('Checking availability...', null);
    fetch(PINCODE_API_URL + '?pincode=' + encodeURIComponent(pincode))
    .then(function (res) { return res.json(); })
    .then(function (data) {
    button.disabled = false;
    if (data && data.serviceable) {
    unlockButtons();
    setMessage('Delivery available for this pincode.', 'is-success');
    } else {
    lockButtons();
    setMessage('Delivery not available for this pincode.', 'is-error');
    }
    })
    .catch(function () {
    button.disabled = false;
    lockButtons();
    setMessage('Could not check delivery right now. Please try again.', 'is-error');
    });
    });
    }
    function initAll() {
    var roots = document.querySelectorAll('[data-pincode-checker]');
    for (var i = 0; i < roots.length; i++) {
    if (!roots[i].hasAttribute('data-pincode-init')) {
    roots[i].setAttribute('data-pincode-init', '');
    initPincodeChecker(roots[i]);
    }
    }
    }
    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
    } else {
    initAll();
    }
    if (window.MutationObserver) {
    new MutationObserver(function () { initAll(); }).observe(document.documentElement, { childList: true, subtree: true });
    }
    })();